

import React from 'react';
import { Zap, Users, ArrowRight, Clock } from 'lucide-react';

const WhyKinosDifferent = () => {
  const differentiators = [
    {
      icon: <Users />,
      title: "Built for Wellness Pros",
      description: "Custom-designed for coaching and wellness professionals, not a generic business tool"
    },
    {
      icon: <Zap />,
      title: "True AI Advantage",
      description: "Our AI learns from your practice to provide personalized recommendations and content"
    },
    {
      icon: <ArrowRight />,
      title: "Seamless Onboarding",
      description: "Be up and running in minutes with our guided setup and integrations"
    },
    {
      icon: <Clock />,
      title: "Time-Saving Automation",
      description: "Replace 5+ separate tools with our comprehensive all-in-one platform"
    }
  ];

  const stats = [
    { value: "30%", label: "Less Admin Time" },
    { value: "5+", label: "Tools Replaced" },
    { value: "40%", label: "Higher Retention" }
  ];

  return (
    <section id="why-different" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-5 py-2 rounded-full text-emerald-700 text-sm font-medium mb-5 bg-gradient-to-r from-emerald-50 to-green-50">
            Why KinOS is Different
          </div>
          <h2 className="text-4xl font-bold mb-5">A New Approach to Practice Management</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We've reimagined what a coaching platform should be, focusing on what matters most to wellness professionals
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentiators.map((item, index) => (
            <div 
              key={index} 
              className="p-8 border-b-2 border-emerald-50 hover:border-emerald-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-full flex items-center justify-center text-emerald-600 mb-6 group-hover:text-emerald-500 transition-colors">
                {React.cloneElement(item.icon, { className: "w-7 h-7" })}
              </div>
              <h3 className="font-semibold text-xl mb-3">{item.title}</h3>
              <p className="text-gray-700 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 flex flex-wrap justify-center">
          <div className="grid md:grid-cols-3 gap-16 w-full max-w-4xl mx-auto">
            {stats.map((stat, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="text-4xl font-bold text-black mb-2">{stat.value}</div>
                <p className="text-gray-600 text-lg">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyKinosDifferent;